import { Grid, ImageListItem } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = {
  variant: 'static' | 'masonry';
  columns: number;
  ref?: React.Ref<any>;
};
const ItemContainer = ({
  variant,
  children,
  columns,
  ref,
}: PropsWithChildren<Props>) => {
  if (variant === 'static') {
    const gridColumn = Math.floor(12 / columns);
    return (
      <Grid className={'tb-card'} ref={ref} size={{ xs: 12, md: gridColumn }}>
        {children}
      </Grid>
    );
  }
  if (variant === 'masonry') {
    return (
      <ImageListItem className={'tb-card'} ref={ref}>
        {children}
      </ImageListItem>
    );
  }
};

export default ItemContainer;
